const getTitleMenuOrders = (t) => [
    {
        name: t('orders-menu-title-sample-orders'),
        linkForRoute: "orders"
    },
    {
        name: t('orders-menu-title-sample-dishes'),
        linkForRoute: "dishes"
    },
    {
        name: t('orders-menu-title-sample-products'),
        linkForRoute: "products"
    },
    {
        name: t('orders-menu-title-sample-deliveries'),
        linkForRoute: "deliveries"
    },
    {
        name: t('orders-menu-title-sample-files'),
        linkForRoute: "files"
    },
]

export {
    getTitleMenuOrders,
}